module.exports = __webpack_public_path__ + "img/heart_sprite.4e4919e6.png";